import { createContext } from "react";

export const NotaDebitoContext = createContext(null);
